import Cookies from 'js-cookie';
function Logout() {
    Cookies.remove('status');
    Cookies.remove('user');
    window.location.href = "/";
}

export default Logout;